// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"18":"8be9ae61","215":"230076ef","872":"33f9ce76"}[chunkId] + ".js";
};